import { Link } from 'react-router';
import PropTypes from 'prop-types';
import React from 'react';

import TimePicker from '../../times/components/TimePicker';
import Info from './Info';

const WaitingListTimes = ({
  barberName,
  serviceName,
  serviceDuration,
  shopName,
  shopAddress,
  shopZip,
  shopLocation,
  timezone,
  day,
  times,
  setTime,
  selectedTime,
  bookingLink,
  removeLink,
}) => (
  <div>
    <h3 className="c-heading c-heading--huge u-mv">Book appointment for {day}</h3>
    <Info
      barberName={barberName}
      serviceName={serviceName}
      serviceDuration={serviceDuration}
      shopName={shopName}
      shopAddress={shopAddress}
      shopZip={shopZip}
      shopLocation={shopLocation}
    />
    <Link className="c-btn c-btn--secondary" to={removeLink}>Remove me from list</Link>
    <div className="u-mt+ u-text-center">
      <h2 className="c-heading c-heading--underline-center c-heading--huge u-mb">Choose time</h2>
      <TimePicker
        times={times}
        setTime={setTime}
        timezone={timezone}
        selectedTime={selectedTime}
      />
      <div className="u-mt">
        {bookingLink &&
          <Link className="c-btn c-btn--primary" to={bookingLink}>Book</Link>
        }
      </div>
    </div>
  </div>
);
WaitingListTimes.propTypes = {
  barberName: PropTypes.string.isRequired,
  serviceName: PropTypes.string.isRequired,
  serviceDuration: PropTypes.number.isRequired,
  shopName: PropTypes.string.isRequired,
  shopAddress: PropTypes.string.isRequired,
  shopZip: PropTypes.string.isRequired,
  shopLocation: PropTypes.shape({
    coordinates: PropTypes.arrayOf(PropTypes.number),
  }),
  day: PropTypes.string.isRequired,
  times: PropTypes.arrayOf(PropTypes.shape({
    time: PropTypes.string,
    waitingListSlotId: PropTypes.string,
  })),
  timezone: PropTypes.string,
  setTime: PropTypes.func.isRequired,
  selectedTime: PropTypes.string.isRequired,
  bookingLink: PropTypes.string.isRequired,
  removeLink: PropTypes.string.isRequired,
};
WaitingListTimes.defaultProps = {
  shopLocation: null,
  timezone: '',
  times: [],
};
export default WaitingListTimes;



// WEBPACK FOOTER //
// ./src/app/waitingList/components/WaitingListTimes.jsx